import { feedServer } from '@/http';

export default {
    async fetchPosts(context) {
        const response = await feedServer.get('/posts', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        const posts = await response.data;
        if (!response.status === 200) {
            const error = new Error(posts.message || 'Failed to fetch posts.');
            throw error;
        }

        const transformedPosts = [];
        for (const key in posts) {
            const post = {
                id: posts[key].post_id,
                content: posts[key].content,
                images: posts[key].images,
                author: posts[key].author,
                likes: posts[key].likes,
                like_count: posts[key].like_count,
                comments: posts[key].comments,
                created_at: posts[key].created_at
            };
            transformedPosts.push(post);
        }
        context.commit('setPosts', transformedPosts);

        return transformedPosts;
    },

    async createPost(context, payload) {
        const photoList = [...payload.photos];
        const postFormData = new FormData();
        postFormData.append('content', payload.content);
        postFormData.append('name', 'default');
        postFormData.append('avatar', 'default');
        photoList.forEach((photo) => {
            postFormData.append('photos', photo);
        });
        const response = await feedServer.post('/posts', postFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (!response.status === 201) {
            const error = new Error(responseData.message || 'Failed to create post.');
            throw error;
        }
        const responseData = response.data;
        const post = {
            id: responseData.post_id,
            content: responseData.content,
            image: responseData.image,
            author: responseData.author,
            likes: responseData.likes,
            like_count: responseData.like_count,
            comments: responseData.comments,
            created_at: responseData.created_at
        };
        context.commit('addPost', post);
    }
}